function moveShares() {
  const titleBlock = document.querySelector('.post__header');
  const shares = document.querySelector('.sharedaddy');
  if (titleBlock && shares) {
    titleBlock.appendChild(shares);
  }
}

moveShares();
